/* Energy Muse header behaviour: the dropdowns open on click, one at a time; the phone menu;
   the announcement bar's dismiss (remembered for the session); chip rows keep the chosen chip in view.
   The markup is rendered by sections/header.liquid; this file only wires it. */
(function(){
'use strict';
function boot(){
  var frag=document.getElementById('emh'); if(!frag) return;
  var menu=document.querySelector('.emh-menu');
  var ann=frag.querySelector('[data-ann]');
  try{ if(ann && sessionStorage.getItem('em-ann')==='off') ann.parentNode.removeChild(ann); }catch(e){}
  var annx=frag.querySelector('.emh-annx');
  if(annx) annx.addEventListener('click',function(){
    var a=frag.querySelector('[data-ann]'); if(a) a.parentNode.removeChild(a);
    try{ sessionStorage.setItem('em-ann','off'); }catch(e){}
  });
  var dds=[].slice.call(document.querySelectorAll('.emh-dd'));
  function setDD(d,o){ d.classList.toggle('open',o); d.querySelector('button').setAttribute('aria-expanded',o?'true':'false'); }
  function closeDDs(except){ dds.forEach(function(d){ if(d!==except) setDD(d,false); }); }
  dds.forEach(function(d){
    d.querySelector('button').addEventListener('click',function(e){ e.stopPropagation(); var open=d.classList.contains('open'); closeDDs(d); setDD(d,!open); });
  });
  if(dds.length){
    document.addEventListener('click',function(e){ if(!dds.some(function(d){ return d.contains(e.target); })) closeDDs(); });
    document.addEventListener('keydown',function(e){ if(e.key==='Escape') closeDDs(); });
  }
  if(!menu) return;
  var mis=[].slice.call(menu.querySelectorAll('.emh-mi'));
  mis.forEach(function(mi){
    mi.querySelector('button').addEventListener('click',function(){
      var open=mi.classList.contains('open');
      mis.forEach(function(x){ x.classList.remove('open'); x.querySelector('button').setAttribute('aria-expanded','false'); });
      mi.classList.toggle('open',!open); mi.querySelector('button').setAttribute('aria-expanded',open?'false':'true');
    });
  });
  var burger=frag.querySelector('.emh-burger'), close=menu.querySelector('.emh-close');
  function set(o){ menu.classList.toggle('open',o); document.body.classList.toggle('emh-open',o); document.documentElement.style.overflow=o?'hidden':''; if(burger) burger.setAttribute('aria-expanded',o?'true':'false'); }
  if(burger) burger.addEventListener('click',function(){ set(true); });
  if(close) close.addEventListener('click',function(){ set(false); });
  menu.querySelectorAll('nav a').forEach(function(a){ a.addEventListener('click',function(){ set(false); }); });
  document.addEventListener('keydown',function(e){ if(e.key==='Escape') set(false); });
}
function keepChipInView(){
  var ROWS='.sfilter,.ssub,.ifilter,.jfilter,.jump,.tabs,.sizes';
  document.addEventListener('click',function(e){
    var row=e.target.closest&&e.target.closest(ROWS); if(!row) return;
    if(row.scrollWidth<=row.clientWidth+1) return;
    var chip=e.target.closest('button,a'); if(!chip||!row.contains(chip)) return;
    if(chip.scrollIntoView) chip.scrollIntoView({block:'nearest',inline:'nearest',behavior:'smooth'});
  },true);
}
/* Sept 23 (Sara): the search opens where you are, and shows what the store has as you type.
   "if the search bar could just come out here ... I don't know that it needs to take them to a complete other page",
   and "it doesn't show you a preview when you're typing of what the products are, so you could just click it."

   The suggestions come from Shopify's own /search/suggest.json, which reads the live catalogue - a product
   published tomorrow is findable the moment it is published, with nothing to index or maintain. The Search link
   keeps its href, so with no JavaScript it still goes to the search page. */
function findBar(){
  var open=document.querySelector('.emh-search'), panel=document.getElementById('emh-find');
  if(!open||!panel) return;
  var q=document.getElementById('emh-q'), sugg=document.getElementById('emh-sugg'),
      shut=panel.querySelector('.emh-find-x'), form=panel.querySelector('form');
  var t=null, last='', ctrl=null;

  function show(on){
    panel.hidden=!on; open.setAttribute('aria-expanded', on?'true':'false');
    if(on){ q.focus(); q.select(); } else { sugg.innerHTML=''; last=''; }
  }
  open.addEventListener('click', function(e){ e.preventDefault(); show(panel.hidden); });
  shut.addEventListener('click', function(){ show(false); open.focus(); });
  document.addEventListener('keydown', function(e){ if(e.key==='Escape' && !panel.hidden){ show(false); open.focus(); } });
  form.addEventListener('submit', function(e){ if(!q.value.trim()) e.preventDefault(); });
  /* a dropdown's own handler stops the click bubbling, so the document-level closers never see it; listening on the
     button itself still fires, and keeps the two from hanging open over each other */
  [].slice.call(document.querySelectorAll('.emh-dd button')).forEach(function(b){
    b.addEventListener('click', function(){ if(!panel.hidden) show(false); });
  });

  function money(c){
    /* the store's own format, handled the way em-product.js handles it - their catalogue runs past $1,000, so the
       separator variants matter - and without the space their format puts after the $, as everywhere else on the site */
    var f=String(window.EM_MONEY||'${{amount}}').replace(/<[^>]+>/g,''), n=Number(c)/100;
    function fmt(d,th,dec){ var parts=n.toFixed(d).split('.'); parts[0]=parts[0].replace(/\B(?=(\d{3})+(?!\d))/g,th); return parts.join(dec); }
    return f.replace(/\{\{\s*(\w+)\s*\}\}/, function(m,k){
      if(k==='amount_no_decimals') return fmt(0,',','.');
      if(k==='amount_with_comma_separator') return fmt(2,'.',',');
      if(k==='amount_no_decimals_with_comma_separator') return fmt(0,'.',',');
      return fmt(2,',','.');
    }).replace('$ ','$');
  }
  function esc(s){ return String(s==null?'':s).replace(/[&<>"]/g, function(m){ return {'&':'&amp;','<':'&lt;','>':'&gt;','"':'&quot;'}[m]; }); }

  function paint(r){
    /* Sept 29: a product that is published only so the bracelet builder can read its price and photograph
       is not something anyone searched for. window.EM_HIDDEN is written by the header from the collection
       named in Theme settings > Energy Muse; absent or empty, this filter does nothing. */
    var hid = window.EM_HIDDEN || [];
    var ps=(r.products||[]).filter(function(p){
      if(!hid.length) return true;
      var h = p.handle || String(p.url||'').split('/products/')[1] || '';
      return hid.indexOf(h.split('?')[0].split('#')[0]) < 0;
    });
    var qs=(r.queries||[]), out='';
    if(ps.length){
      out+='<span class="emh-sg">Products</span>';
      out+=ps.map(function(p){
        var img=(p.featured_image&&p.featured_image.url)?'<img src="'+esc(p.featured_image.url)+'" alt="" loading="lazy">':'<span></span>';
        /* predictive search gives the price in currency units as a string ("35.89"), not cents, and carries the
           compare-at as well - so a marked-down piece reads here the way it reads everywhere else on the site */
        var now=(p.price!=null)?money(Number(p.price)*100):'';
        /* Sept 23: predictive search has no compare_at_price - it returns compare_at_price_min / _max, as strings,
           and "0.00" when there is no markdown. Reading the wrong key meant the panel quietly showed no sale at all
           while the cards beside it did. _min is the one that pairs with the price shown, which is the lowest variant. */
        var wasN=Number(p.compare_at_price_min||p.compare_at_price||0);
        var price=(p.price==null)?'<span class="p"></span>'
          :(wasN>Number(p.price)
              ? '<span class="p"><s class="em-was">'+esc(money(wasN*100))+'</s><span class="em-now">'+esc(now)+'</span></span>'
              : '<span class="p">'+esc(now)+'</span>');
        return '<a class="emh-hit" href="'+esc(p.url)+'">'+img+'<span class="t">'+esc(p.title)+'</span>'+price+'</a>';
      }).join('');
    }
    if(qs.length){
      out+='<span class="emh-sg">Try</span>'+qs.map(function(w){
        return '<a class="emh-word" href="/search?q='+encodeURIComponent(w.text)+'">'+esc(w.text)+'</a>';
      }).join('');
    }
    if(!out) out='<p class="emh-none">Nothing matched yet. Try a stone, a frequency, or a word like sizing.</p>';
    sugg.innerHTML=out;
  }

  function ask(term){
    if(ctrl) ctrl.abort();
    ctrl = ('AbortController' in window) ? new AbortController() : null;
    var url='/search/suggest.json?q='+encodeURIComponent(term)
      +'&resources[type]=product,query&resources[limit]=10&resources[options][unavailable_products]=last';
    fetch(url, ctrl?{signal:ctrl.signal}:undefined)
      .then(function(r){ return r.ok?r.json():null; })
      .then(function(j){ if(j&&j.resources&&j.resources.results) paint(j.resources.results); })
      .catch(function(){ /* a cancelled or failed lookup simply leaves what is there */ });
  }

  q.addEventListener('input', function(){
    var v=q.value.trim();
    clearTimeout(t);
    if(v.length<2){ sugg.innerHTML=''; last=''; return; }
    if(v===last) return;
    /* a short wait so a fast typist makes one request, not eight */
    t=setTimeout(function(){ last=v; ask(v); }, 180);
  });
}
if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',function(){ boot(); keepChipInView(); findBar(); });
else { boot(); keepChipInView(); findBar(); }
})();
